import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setFiltersVisibility } from '../../../../../common/actions';
import { searchSuppliers, searchCategories } from '../../../stocks/actions';
import { fetchDefaultLowStockThreshold } from '../../actions';
import { SearchableSelect, Dropdown, Input } from '../../../../../common/ui';
import FilterModal from '../../../../../common/components/FilterModal';
import styles from './styles.module.css';

const PRODUCT_TYPE_OPTIONS = [
  { value: 'ALL', label: 'All Products' },
  { value: 'STOCK', label: 'Stock' },
  { value: 'NON_STOCK', label: 'Non Stock' },
];

const REMAINING_QTY_OPTIONS = [
  { value: 'ALL', label: 'All Stocks' },
  { value: 'NON_ZERO', label: 'Non Zero' },
  { value: 'ZERO', label: 'Zero' },
  { value: 'LOW_STOCK', label: 'Low Stock' },
];

const FilterComp = ({
  stocks: { suggestSuppliers, suggestCategories },
  setFiltersVisibility,
  setFilters,
  searchSuppliers,
  searchCategories,
  fetchDefaultLowStockThreshold,
  selectedSupplier,
  setselectedSupplier,
  selectedCategory,
  setselectedCategory,
  productType,
  setProductType,
  remainingQuantity,
  setRemainingQuantity,
  lowStockThreshold,
  setLowStockThreshold,
}) => {
  const handleApply = () => {
    const newFilters = {};

    if (selectedSupplier) {
      newFilters.supplier = selectedSupplier;
    }
    if (selectedCategory) {
      newFilters.category = selectedCategory;
    }
    if (productType && productType !== 'ALL') {
      newFilters.productType = productType;
    }
    if (remainingQuantity && remainingQuantity !== 'ALL') {
      newFilters.remainingQuantity = remainingQuantity;
      if (remainingQuantity === 'LOW_STOCK' && lowStockThreshold) {
        newFilters.lowStockThresholdValue = lowStockThreshold;
      }
    }

    setFilters(newFilters);
    setFiltersVisibility(false);
  };

  useEffect(() => {
    searchSuppliers();
  }, [searchSuppliers]);

  useEffect(() => {
    if (remainingQuantity !== 'LOW_STOCK' || lowStockThreshold) return;

    fetchDefaultLowStockThreshold().then((value) => {
      if (value) setLowStockThreshold(value);
    });
  }, [remainingQuantity]);

  const supplierOptions = Array.isArray(suggestSuppliers) ? suggestSuppliers : [];

  return (
    <FilterModal title="Filter by" onApply={handleApply}>
      <div className={styles.filterOptionName}>By Category</div>
      <SearchableSelect
        async
        options={suggestCategories || []}
        getOptionLabel={(o) => o.name}
        getOptionValue={(o) => o.id}
        value={selectedCategory?.id}
        onChange={(id) => { if (!id) setselectedCategory(null); }}
        onSelect={(opt) => setselectedCategory(opt)}
        onSearch={(keyword) => searchCategories(keyword)}
        placeholder="Enter name"
        minSearchLength={1}
      />

      <div className={styles.spacer} />

      <div className={styles.filterOptionName}>By Supplier</div>
      <SearchableSelect
        options={supplierOptions}
        getOptionLabel={(o) => o.companyname}
        getOptionValue={(o) => o.id}
        value={selectedSupplier?.id}
        onChange={(id) => { if (!id) setselectedSupplier(null); }}
        onSelect={(opt) => setselectedSupplier(opt)}
        placeholder="Enter name"
      />

      <div className={styles.spacer} />

      <div className={styles.filterOptionName}>Product Type</div>
      <Dropdown
        id="filter-product-type"
        options={PRODUCT_TYPE_OPTIONS}
        value={productType}
        onChange={(val) => setProductType(val)}
      />

      <div className={styles.spacer} />

      <div className={styles.filterOptionName}>Remaining Quantity</div>
      <Dropdown
        id="filter-remaining-qty"
        options={REMAINING_QTY_OPTIONS}
        value={remainingQuantity}
        onChange={(val) => {
          setRemainingQuantity(val);
          if (val !== 'LOW_STOCK') setLowStockThreshold('');
        }}
      />

      {remainingQuantity === 'LOW_STOCK' && (
        <div className={styles.thresholdWrap}>
          <Input
            id="filter-low-stock-threshold"
            label="Low Stock Threshold"
            type="number"
            value={lowStockThreshold}
            onChange={(val) => setLowStockThreshold(val)}
            placeholder="Enter threshold value"
          />
        </div>
      )}
    </FilterModal>
  );
};

FilterComp.propTypes = {
  setFiltersVisibility: PropTypes.func.isRequired,
  searchSuppliers: PropTypes.func.isRequired,
  searchCategories: PropTypes.func.isRequired,
  fetchDefaultLowStockThreshold: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  selectedSupplier: PropTypes.object,
  setselectedSupplier: PropTypes.func.isRequired,
  selectedCategory: PropTypes.object,
  setselectedCategory: PropTypes.func.isRequired,
  productType: PropTypes.string.isRequired,
  setProductType: PropTypes.func.isRequired,
  remainingQuantity: PropTypes.string.isRequired,
  setRemainingQuantity: PropTypes.func.isRequired,
  lowStockThreshold: PropTypes.string.isRequired,
  setLowStockThreshold: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  stocks: state.stocksState,
});

export default connect(mapStateToProps, {
  setFiltersVisibility,
  searchSuppliers,
  searchCategories,
  fetchDefaultLowStockThreshold,
})(FilterComp);
